
export const ICON_SIZES = {
  xs: "16px",
  sm: "20px",
  base: "24px",
  md: "24px",
  lg: "32px",
  xl: "40px",
  "2xl": "48px",
  "3xl": "64px",
  
  small: "20px",
  medium: "24px",
  large: "32px",
  
  button: "20px",
  header: "24px",
  card: "32px",
  hero: "48px",
} as const;

export const ICON_STROKE_WIDTH = {
  thin: 1,
  normal: 1.5,
  medium: 2,
  bold: 2.5,
} as const;

export type IconSize = typeof ICON_SIZES;














